/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { MyProfileTeam } from "./MyProfileTeam";
import {
  MyProfileTeamFromJSON,
  MyProfileTeamFromJSONTyped,
  MyProfileTeamToJSON,
  MyProfileTeamToJSONTyped,
} from "./MyProfileTeam";
import type { EngagementType } from "./EngagementType";
import {
  EngagementTypeFromJSON,
  EngagementTypeFromJSONTyped,
  EngagementTypeToJSON,
  EngagementTypeToJSONTyped,
} from "./EngagementType";

/**
 * The caller's own profile details. Contains the caller's own (sensitive) personal contact details --- only ever returned to the authenticated owner, never keyed by an arbitrary id --- so it needs no People permission.
 * @export
 * @interface MyProfileDetails
 */
export interface MyProfileDetails {
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  personalEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  personalPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  mailingAddress?: string | null;
  /**
   *
   * @type {number}
   * @memberof MyProfileDetails
   */
  birthdayMonth?: number | null;
  /**
   *
   * @type {number}
   * @memberof MyProfileDetails
   */
  birthdayDay?: number | null;
  /**
   *
   * @type {LocalDate}
   * @memberof MyProfileDetails
   */
  joinDate?: LocalDate | null;
  /**
   *
   * @type {Array<MyProfileTeam>}
   * @memberof MyProfileDetails
   */
  teams: Array<MyProfileTeam>;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  keyDatesPath: string;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  legalFullName?: string | null;
  /**
   *
   * @type {string}
   * @memberof MyProfileDetails
   */
  jobTitle?: string | null;
  /**
   *
   * @type {EngagementType}
   * @memberof MyProfileDetails
   */
  engagementType?: EngagementType | null;
  /**
   *
   * @type {CurrencyCode}
   * @memberof MyProfileDetails
   */
  currency?: CurrencyCode | null;
  /**
   *
   * @type {LocalDate}
   * @memberof MyProfileDetails
   */
  endDate?: LocalDate | null;
  /**
   *
   * @type {boolean}
   * @memberof MyProfileDetails
   */
  engagementLetterReady: boolean;
}

/**
 * Check if a given object implements the MyProfileDetails interface.
 */
export function instanceOfMyProfileDetails(
  value: object,
): value is MyProfileDetails {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("firstName" in value) || value["firstName"] === undefined) return false;
  if (!("lastName" in value) || value["lastName"] === undefined) return false;
  if (!("teams" in value) || value["teams"] === undefined) return false;
  if (!("keyDatesPath" in value) || value["keyDatesPath"] === undefined)
    return false;
  if (
    !("engagementLetterReady" in value) ||
    value["engagementLetterReady"] === undefined
  )
    return false;
  return true;
}

export function MyProfileDetailsFromJSON(json: any): MyProfileDetails {
  return MyProfileDetailsFromJSONTyped(json, false);
}

export function MyProfileDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MyProfileDetails {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    email: json["email"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    personalEmail:
      json["personalEmail"] == null ? undefined : json["personalEmail"],
    personalPhone:
      json["personalPhone"] == null ? undefined : json["personalPhone"],
    mailingAddress:
      json["mailingAddress"] == null ? undefined : json["mailingAddress"],
    birthdayMonth:
      json["birthdayMonth"] == null ? undefined : json["birthdayMonth"],
    birthdayDay: json["birthdayDay"] == null ? undefined : json["birthdayDay"],
    joinDate: json["joinDate"] == null ? undefined : json["joinDate"],
    teams: (json["teams"] as Array<any>).map(MyProfileTeamFromJSON),
    keyDatesPath: json["keyDatesPath"],
    legalFullName:
      json["legalFullName"] == null ? undefined : json["legalFullName"],
    jobTitle: json["jobTitle"] == null ? undefined : json["jobTitle"],
    engagementType:
      json["engagementType"] == null
        ? undefined
        : EngagementTypeFromJSON(json["engagementType"]),
    currency:
      json["currency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["currency"]),
    endDate: json["endDate"] == null ? undefined : json["endDate"],
    engagementLetterReady: json["engagementLetterReady"],
  };
}

export function MyProfileDetailsToJSON(json: any): MyProfileDetails {
  return MyProfileDetailsToJSONTyped(json, false);
}

export function MyProfileDetailsToJSONTyped(
  value?: MyProfileDetails | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    email: value["email"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    personalEmail: value["personalEmail"],
    personalPhone: value["personalPhone"],
    mailingAddress: value["mailingAddress"],
    birthdayMonth: value["birthdayMonth"],
    birthdayDay: value["birthdayDay"],
    joinDate: value["joinDate"],
    teams: (value["teams"] as Array<any>).map(MyProfileTeamToJSON),
    keyDatesPath: value["keyDatesPath"],
    legalFullName: value["legalFullName"],
    jobTitle: value["jobTitle"],
    engagementType: EngagementTypeToJSON(value["engagementType"]),
    currency: CurrencyCodeToJSON(value["currency"]),
    endDate: value["endDate"],
    engagementLetterReady: value["engagementLetterReady"],
  };
}
